import { Dispatch } from '../../../../../types/actions';
import { SNACKBAR_BUTTON_CLOSE, SNACKBAR_BUTTON_UNDO } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { addUpdateSnackbarWithBubble } from '../addUpdateSnackbarWithBubble/addUpdateSnackbarWithBubble';
import { ISnackbarUndo } from './types';
import { SNACKBAR_TIMER_UNDO } from '../../hocs/SnackbarHOC/constants';
import { SnackbarVariant } from '../../store/types';

export const snackbarUndoDefault = (
    options: ISnackbarUndo,
) => {
    return (dispatch: Dispatch) => {
        const shouldUseControlsDefault = options.buttons === undefined;
        if (shouldUseControlsDefault) {
            options.buttons = [
                {
                    onClick: () => {
                        dispatch(getDefaultActionEvent(options.id, options.actionApply));
                    },
                    text: SNACKBAR_BUTTON_CLOSE,
                },
                {
                    onClick: () => {
                        dispatch(getDefaultActionEvent(options.id, options.actionUndo));
                    },
                    isPrimary: true,
                    isTimer: true,
                    text: SNACKBAR_BUTTON_UNDO
                },
            ];
        }

        dispatch(addUpdateSnackbarWithBubble({
            ...options,
            variant: SnackbarVariant.UNDO,
            timer: SNACKBAR_TIMER_UNDO,
            onTimer: () => {
                dispatch(getDefaultActionEvent(options.id, options.actionApply));
                if (options.actionTimer)
                    options.actionTimer();
            },
            onHide: () => {
                dispatch(getDefaultActionEvent(options.id, options.actionApply))
            }
        }));
    }
};
